import { AmbassadorMark } from '@/components/AmbassadorMark';
import { FitName } from './FitName';

interface IdentityProps {
  name: string;
  /** Enrolled in the ambassador programme — earns the mark above the name. */
  ambassador?: boolean;
}

/**
 * The page's name, read the same by everyone, with the tagline under it. The
 * owner reads `EditableName` in its place, over their `PageLink`.
 */
export function Identity({ name, ambassador = false }: IdentityProps) {
  return (
    // No top padding: `PageFrame` owns the distance from the top of the page.
    <div className="flex flex-col gap-3">
      <FitName name={name}>
        {name}
        {ambassador && <AmbassadorMark />}
      </FitName>
    </div>
  );
}
